// Rotas de autenticação
const authRoutes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/live-v1/pages/auth/login.vue'),
    meta: {
      title: 'Login',
      guestOnly: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/live-v1/pages/auth/register.vue'),
    meta: {
      title: 'Cadastro',
      guestOnly: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/live-v1/pages/auth/forgot-password.vue'),
    meta: {
      title: 'Recuperar Senha',
      guestOnly: true,
    },
  },
  {
    path: '/auth/redeem-password',
    name: 'redeem-password',
    component: () => import('../views/live-v1/pages/auth/redeem-password.vue'),
    meta: {
      title: 'Redefinir Senha',
      guestOnly: true,
      requiresAuth: false,
    },
  },
  {
    // Redirect para compatibilidade com URL do Supabase
    path: '/reset-password',
    redirect: to => {
      return { path: '/auth/redeem-password', query: to.query };
    },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: () => import('../views/components/access-denied.vue'),
    meta: {
      title: 'Acesso Negado',
    },
  },
];

// Rotas públicas (acessíveis sem autenticação)
const publicRoutes = [
  {
    path: '/termos-de-uso',
    name: 'termos-de-uso',
    component: () => import('../views/live-v1/pages/termos-de-uso.vue'),
    meta: {
      title: 'Termos de Uso',
    },
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    component: () =>
      import('../views/live-v1/pages/politica-de-privacidade.vue'),
    meta: {
      title: 'Política de Privacidade',
    },
  },
  {
    path: '/auth/callback',
    name: 'magic-link-callback',
    component: () =>
      import('../views/live-v1/pages/auth/magic-link-callback.vue'),
    meta: { title: 'Validação de Acesso', requiresAuth: false },
  },
  // Nova rota para atualização de senha
  {
    path: '/auth/update-password',
    name: 'update-password',
    component: () => import('../views/live-v1/pages/auth/update-password.vue'),
    meta: {
      title: 'Atualizar Senha',
      requiresAuth: true,
      allowGuest: true,
      allowFirstAccess: true,
    },
  },
];

// Rotas protegidas (requerem autenticação)
const protectedRoutes = [
  // Aguardando Aprovação
  {
    path: '/awaiting-approval',
    name: 'awaiting-approval',
    meta: {
      title: 'Aguardando Aprovação',
      requiresAuth: true,
      allowGuest: true,
    },
    component: () =>
      import('../views/live-v1/pages/awaiting-approval/index.vue'),
  },
  // Fornecedores
  {
    path: '/suppliers',
    name: 'suppliers',
    meta: {
      title: 'Lista de Fornecedores',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/suppliers/index.vue'),
  },
  {
    path: '/suppliers/:id',
    name: 'suppliers-view',
    meta: {
      title: 'Detalhes do Fornecedor',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/suppliers/view.vue'),
  },
  // Categorias
  {
    path: '/categories',
    name: 'categories',
    meta: {
      title: 'Lista de Categorias',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/categories/index.vue'),
  },
  {
    path: '/categories/:id',
    name: 'categories-view',
    meta: {
      title: 'Detalhes da Categoria',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/categories/view.vue'),
  },
  // Denúncias (Usuário)
  {
    path: '/reports/my-reports',
    name: 'my-reports',
    meta: {
      title: 'Minhas Denúncias',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/reports/my-reports.vue'),
  },
  // Perfil
  {
    path: '/me',
    name: 'me',
    component: () => import('@/views/live-v1/pages/me/index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Meu Perfil',
    },
  },
  {
    path: '/me/edit',
    name: 'me-edit',
    component: () => import('@/views/live-v1/pages/me/edit.vue'),
    meta: {
      requiresAuth: true,
      title: 'Editar Perfil',
    },
  },
  // User Dashboard
  {
    path: '/dashboard',
    name: 'user-dashboard',
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
    },
    component: () => import('../views/live-v1/pages/user/user-dashboard.vue'),
  },
];

// Rotas de administração (requerem permissões de admin)
const adminRoutes = [
  {
    path: '/users/',
    name: 'users-list',
    meta: {
      title: 'Lista de Usuários',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/users/users-list.vue'),
  },
  {
    path: '/pending-suppliers',
    name: 'pending-suppliers',
    meta: {
      title: 'Fornecedores Pendentes',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () =>
      import('../views/live-v1/pages/pending-suppliers/index.vue'),
  },
  // Denúncias (Admin)
  {
    path: '/reports/admin',
    name: 'admin-reports',
    meta: {
      title: 'Gerenciar Denúncias',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/reports/admin-reports.vue'),
  },
  // Analytics Dashboard (Admin)
  {
    path: '/admin/analytics',
    name: 'admin-analytics',
    meta: {
      title: 'Dashboard Admin',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/admin/admin-analytics.vue'),
  },
  // Site Analytics (Plausible)
  {
    path: '/admin/site-analytics',
    name: 'site-analytics',
    meta: {
      title: 'Analytics do Site',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/admin/site-analytics.vue'),
  },
  {
    path: '/users/:id/edit',
    name: 'user-edit',
    meta: {
      title: 'Editar Usuário',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/users/users-edit.vue'),
  },
  {
    path: '/users/:id',
    name: 'user-view',
    meta: {
      title: 'Visualizar Usuário',
      requiresAuth: true,
      requiresAdmin: true,
    },
    component: () => import('../views/live-v1/pages/users/users-view.vue'),
  },
  // Fornecedores
  {
    path: '/suppliers/create',
    name: 'suppliers-create',
    meta: {
      title: 'Adicionar Fornecedor',
      requiresAuth: true,
      requiredRole: ['ADMIN'],
    },
    component: () => import('../views/live-v1/pages/suppliers/create.vue'),
  },
  {
    path: '/suppliers/:id/edit',
    name: 'suppliers-edit',
    meta: {
      title: 'Editar Fornecedor',
      requiresAuth: true,
      requiredRole: ['ADMIN'],
    },
    component: () => import('../views/live-v1/pages/suppliers/edit.vue'),
  },
  // Categorias
  {
    path: '/categories/create',
    name: 'categories-create',
    meta: {
      title: 'Adicionar Categoria',
      requiresAuth: true,
      requiredRole: ['ADMIN'],
    },
    component: () => import('../views/live-v1/pages/categories/create.vue'),
  },
  {
    path: '/categories/:id/edit',
    name: 'categories-edit',
    meta: {
      title: 'Editar Categoria',
      requiresAuth: true,
      requiredRole: ['ADMIN'],
    },
    component: () => import('../views/live-v1/pages/categories/edit.vue'),
  },
];

// Combina todas as rotas
export default [
  ...authRoutes,
  ...publicRoutes,
  ...protectedRoutes,
  ...adminRoutes,
  // Rota de fallback
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/live-v1/pages/auth/not-found.vue'),
    meta: { title: 'Página Não Encontrada' },
  },
];
